import axios from 'axios';
import { API_URL } from '@/config/env';

const client = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    responseType: 'json'
});

export default {
    async execute(method, resource, data) {
        return client({
            method,
            url: resource,
            data
        }).then(response => {
            console.log("base.service.js GLOBAL LOG ajax query method:" + method + " url:" + resource);
            console.log('base.service.js GLOBAL response data log', response.data);
            return response.data
        })
    },
    // AUTH methods
    checkLoggin(data) {
        return this.execute('post', '/UserSession/login', data);
    },
    checkUser() {
        return this.execute('get', '/UserSession/currentUser');
    },
    // default service methods
    get(resource, option) {
        return this.execute('get', `${resource}`, option);
    },
    post(resource, data) {
        return this.execute('post', `${resource}`, data);
    },
    create(resource, data) {
        return this.execute('post', `${resource}`, data);
    },
    update(resource, id, data) {
        return this.execute('put', `${resource}{id}`, data);
    },
    delete(resource, id) {
        return this.execute('post', `${resource}{id}`);
    },
    // service orders
    getOrders() {
        return this.execute('get', `/Data/order/`);
    },
    getOrder(id) {
        return this.execute('get', `/orders/${id}`);
    },
    createOrder(data) {
        return this.execute('post', '/Exec/order/act/new/', data);
    },
    updateOrder(id, data) {
        return this.execute('put', `/orders/${id}`, data);
    },
    deleteOrder(id) {
        return this.execute('delete', `/orders/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/services/base.service.js